import React from 'react'
import { useQuery, useMutation, gql } from '@apollo/client'
import Header from '../components/Headers/Header'
import { restaurants, updateCommission } from '../apollo'
import CustomLoader from '../components/Loader/CustomLoader'
import useGlobalStyles from '../utils/globalStyles'
import { Container, Box, Typography, Grid, Input, Button } from '@mui/material'
import useStyles from '../components/Rider/styles'
import { NotificationContainer, NotificationManager } from 'react-notifications'
import 'react-notifications/lib/notifications.css'
import { useTranslation, withTranslation } from 'react-i18next'

const GET_RESTAURANTS = gql`
  ${restaurants}
`
const UPDATE_COMMISSION = gql`
  ${updateCommission}
`
const Commission = () => {
  const getValues = id => {
    const commissionRate = document.getElementById(id).value
    return { id, commissionRate: +commissionRate }
  }
  const [mutate, { error }] = useMutation(UPDATE_COMMISSION)

  const { data, error: errorQuery, loading: loadingQuery } = useQuery(
    GET_RESTAURANTS
  )
  console.log(data)
  const globalClasses = useGlobalStyles()
  const classes = useStyles()
  const { t } = useTranslation()
  const handleSuccessButtonClick = () => {
    NotificationManager.success('Update Successful', 'Commission Rates', 3000, {
      className: 'customNotification'
    })
  }
  const handleErrorButtonClick = () => {
    NotificationManager.error('Update Error', 'Commission Rates', 3000, {
      className: 'customNotification'
    })
  }

  return (
    <>
      <Header />
      <Grid container>
        <NotificationContainer />
        <Grid item xs={12}>
          <Container className={globalClasses.flex} fluid>
            <Box container className={classes.container}>
              <Box item className={classes.heading}>
                <Typography variant="h6" className={classes.text}>
                  {t('CommissionRates')}
                </Typography>
              </Box>
              <Box className={classes.form}>
                {errorQuery ? <span>error {errorQuery.message}</span> : null}
                {loadingQuery ? (
                  <CustomLoader />
                ) : (
                  data && (
                    <>
                      {data.restaurants.map(restaurant => (
                        <Grid
                          key={restaurant._id}
                          container
                          columnSpacing={2}
                          alignItems="center"
                          sx={{
                            py: 1.5,
                            borderBottom: '1px solid',
                            borderColor: 'divider',
                            '&:last-of-type': { borderBottom: 'none' }
                          }}>
                          <Grid item xs={12} sm={5}>
                            <Typography
                              sx={{ fontSize: 14, fontWeight: 500 }}
                              color="text.primary">
                              {restaurant.name}
                            </Typography>
                          </Grid>
                          <Grid item xs={8} sm={4}>
                            <Input
                              disableUnderline
                              className={globalClasses.input}
                              style={{ marginTop: 0 }}
                              id={restaurant._id}
                              placeholder={t('PHCommission')}
                              inputProps={{ min: 0 }}
                              type="number"
                              step="1"
                              defaultValue={restaurant.commissionRate}
                            />
                          </Grid>
                          <Grid item xs={4} sm={3}>
                            <Button
                              className={globalClasses.button}
                              style={{ marginTop: 0 }}
                              onClick={() => {
                                const result = getValues(restaurant._id)
                                mutate({
                                  variables: result,
                                  onCompleted: data => {
                                    handleSuccessButtonClick()
                                  }
                                })
                              }}>
                              {t('Save')}
                            </Button>
                            {error && <span>{error.message}</span>}
                          </Grid>
                        </Grid>
                      ))}
                      <Box mt={2}>{error && handleErrorButtonClick()}</Box>
                    </>
                  )
                )}
              </Box>
            </Box>
          </Container>
        </Grid>
      </Grid>
    </>
  )
}
export default withTranslation()(Commission)
